import React from "react";
var TailDown = /*#__PURE__*/React.createElement("svg", {
  width: "14",
  height: "15",
  viewBox: "0 0 14 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.34375 13.8438L12.8438 8.34375C13.0312 8.15625 13.0312 7.8125 12.8438 7.625C12.6562 7.4375 12.3125 7.4375 12.125 7.625L7.5 12.2812V0.5C7.5 0.21875 7.25 0 7 0C6.71875 0 6.5 0.21875 6.5 0.5V12.2812L1.84375 7.625C1.65625 7.4375 1.3125 7.4375 1.125 7.625C0.9375 7.8125 0.9375 8.15625 1.125 8.34375L6.625 13.8438C6.8125 14.0312 7.15625 14.0312 7.34375 13.8438Z",
  fill: "#1F1F1F"
}));
export default TailDown;